import React, { useContext } from "react";
import styled from "styled-components";
// Components
// Assets
import HeaderImage from "../../assets/img/landing-image.jpg";
import QuotesIcon from "../../assets/svg/Quotes";
import Dots from "../../assets/svg/Dots";
import { LanguageContext } from "../../screens/LanguageContext";  // Import the context

export default function Header() {
  const { language } = useContext(LanguageContext); // Access the language context

  // Translations based on selected language
  const translations = {
    en: {
      title: "Your Trusted Packaging Partner.",
      description:
        "Specializing in the production of high-quality plastic bags, eco-friendly solutions, and multi-layer laminations. From garbage rolls to custom-printed pouches and advanced food-grade packaging, we cater to all your packaging needs with precision and innovation.",
      quote: '"Great packaging does more than protect—it represents your brand and values. We are here to ensure your products shine from the inside out."',
      company: "Al Itqan Packaging"
    },
    ar: {
      title: "شريكك الموثوق في التعبئة والتغليف.",
      description:
        "متخصصون في إنتاج أكياس البلاستيك عالية الجودة، والحلول الصديقة للبيئة، والتغليف متعدد الطبقات. من لفائف القمامة إلى الأكياس المطبوعة حسب الطلب والتغليف الغذائي المتقدم، نحن نقدم جميع احتياجات التعبئة والتغليف بدقة وابتكار.",
      quote: '"التغليف الجيد لا يحمي فحسب، بل يمثل علامتك التجارية وقيمك. نحن هنا لضمان أن تتألق منتجاتك من الداخل إلى الخارج."',
      company: "شركة الاتقان للتعبئة والتغليف"
    },
  };

  const { title, description, quote, company } = translations[language];

  return (
    <Wrapper id="home" className="container flexSpaceCenter">
      <LeftSide className="flexCenter">
        <div>
          <h1 className="extraBold font60">{title}</h1>
          <HeaderP className="font13 semiBold">{description}</HeaderP>
        </div>
      </LeftSide>
      <RightSide>
        <ImageWrapper>
          <Img className="radius8" src={HeaderImage} alt="office" style={{ zIndex: 9 }} />
          <QuoteWrapper className="flexCenter darkBg radius8">
            <QuotesWrapper>
              <QuotesIcon />
            </QuotesWrapper>
            <div>
              <p className="font15 whiteColor">
                <em>{quote}</em>
              </p>
              <p className="font13 orangeColor textRight" style={{ marginTop: '10px' }}>
                {company}
              </p>
            </div>
          </QuoteWrapper>
          <DotsWrapper>
            <Dots />
          </DotsWrapper>
        </ImageWrapper>
        <GreyDiv className="lightBg"></GreyDiv>
      </RightSide>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  padding-top: 80px;
  width: 100%;
  min-height: 840px;
  @media (max-width: 960px) {
    flex-direction: column;
  }
`;
const LeftSide = styled.div`
  width: 50%;
  height: 100%;
  @media (max-width: 960px) {
    width: 100%;
    order: 2;
    margin: 50px 0;
    text-align: center;
  }
  @media (max-width: 560px) {
    margin: 80px 0 50px 0;
  }
`;
const RightSide = styled.div`
  width: 50%;
  height: 100%;
  @media (max-width: 960px) {
    width: 100%;
    order: 1;
    margin-top: 30px;
  }
`;
const HeaderP = styled.div`
  max-width: 470px;
  padding: 15px 0 50px 0;
  line-height: 1.5rem;
  @media (max-width: 960px) {
    padding: 15px 0 50px 0;
    text-align: center;
    max-width: 100%;
  }
`;
const BtnWrapper = styled.div`
  max-width: 190px;
  @media (max-width: 960px) {
    margin: 0 auto;
  }
`;
const GreyDiv = styled.div`
  width: 30%;
  height: 700px;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 0;
  @media (max-width: 960px) {
    display: none;
  }
`;
const ImageWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  position: relative;
  z-index: 9;
  @media (max-width: 960px) {
    width: 100%;
    justify-content: center;
  }
`;
const Img = styled.img`
  @media (max-width: 560px) {
    width: 80%;
    height: auto;
  }
`;
const QuoteWrapper = styled.div`
  position: absolute;
  left: 0;
  bottom: 50px;
  max-width: 330px;
  padding: 30px;
  z-index: 99;
  @media (max-width: 960px) {
    left: 20px;
  }
  @media (max-width: 560px) {
    bottom: -50px;
  }
`;
const QuotesWrapper = styled.div`
  position: absolute;
  left: -20px;
  top: -10px;
`;
const DotsWrapper = styled.div`
  position: absolute;
  right: -100px;
  bottom: 100px;
  z-index: 2;
  @media (max-width: 960px) {
    right: 100px;
  }
  @media (max-width: 560px) {
    display: none;
  }
`;
